import { NgModule } from '@angular/core';
import { ProgressBarComponent } from './progress-bar/progress-bar';
@NgModule({
	declarations: [ProgressBarComponent],
	imports: [],
	exports: [ProgressBarComponent]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts